import { action, makeObservable, observable, computed } from "mobx";
import { UploadFile } from "antd";
import AddCompanyStore from "./addCompany_store";

type UploadImageType =
  | "legalPersonIdFront"
  | "legalPersonIdBack"
  | "businessLicenseImage"
  | "bankPermitImage"
  | "agentIdFront"
  | "agentIdBack";

class UploadImgStore {
  addCompanyStore: AddCompanyStore;
  name: UploadImageType;
  constructor(baseStore: AddCompanyStore, name: UploadImageType) {
    this.addCompanyStore = baseStore;
    this.name = name;
    makeObservable(this);
  }
  @observable _fileList: UploadFile[] = []; //上传营业执照图片文件
  @observable isEdited: boolean = false; //

  @computed get fileList(): UploadFile[] {
    if (this.isEdited) {
      return this._fileList;
    } else {
      return this.addCompanyStore[this.name]
        ? [
            {
              uid: "-1",
              name: "image.png",
              status: "done",
              url: this.addCompanyStore[this.name],
            },
          ]
        : [];
    }
  }

  @action
  setFileList(fileList: UploadFile[], file?: any): void {
    this._fileList = fileList;
    this.isEdited = true;

    if (fileList.length > 0) {
      this.addCompanyStore.uploadImageFile(this.name, file);
    } else {
      if (this.name === "agentIdFront" || this.name === "agentIdBack"){
        this.addCompanyStore.operatorFormData[this.name] = "";
      }else{
        this.addCompanyStore.enterpriseRealNameFormData[this.name] = "";
      }
    }
  }

  @action
  reset() {
    this._fileList = [];
    this.isEdited = false;
  }
}

export default UploadImgStore;
